/* -------------------------- moving styles from promotion-card ----------------------- */
.item {
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: var(--spacing-small);
    border-bottom: 1px solid var(--color-border);
    gap: 0.5rem;
}

.item__shadow {
    border: 1px solid var(--color-border);
    border-radius: var(--border-small);
    margin: var(--spacing-small);
    box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0px 10px 24px -14px rgba(0, 0, 0, 0.5);
}

.item__content {
    display: flex;
    align-items: center;
    flex: 1;
    flex-basis: 250px;
    gap: var(--spacing-small);
}

.item__logo {
    width: 35px;
    height: 35px;
    align-self: center;
}

.item__description {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1;
}

.item__book-name,
.featured-item__book-name {
    font-size: var(--font-size-subcaption);
    font-weight: var(--font-weight-bold);
    line-height: 14px;
    color: var(--color-secondary);
}

.item__cta,
.featured-item__cta {
    color: var(--color-primary);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-bold);
    line-height: 18px;
}

.item__terms,
.featured-item__terms {
    font-size: var(--font-size-tiny);
    line-height: 14px;
    color: var(--color-secondary);
}

.item__position-circle {
    background-color: var(--color-quaternary);
    color: var(--color-primary);
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.item__values {
    width: 45%;
}

.item__value-props {
    font-size: var(--font-size-subcaption);
    font-weight: var(--font-weight-normal);
    color: var(--color-secondary);
    list-style-type: disc;
    margin-left: -1rem;
}

.item__review-link {
    padding-right: 20px;
    font-size: 0.75rem;
    text-align: center;
}

.button__half {
    width: 48%;
}

.buttons-condensed {
    max-width: 30% !important;
}

@media (max-width: 800px) {
    .item__content {
        flex-wrap: wrap;
    }

    .item__values {
        flex-basis: 100%;
    }

    .buttons-condensed {
        max-width: 100% !important;
    }
}

.buttons {
    width: 100%;
    display: flex;
    flex: 1 1 50px;
    justify-content: space-between;
    gap: var(--spacing-small);
    flex-basis: 300px;
}

.button {
    border: 1px solid var(--color-border);
    padding: var(--spacing-small) 0;
    border-radius: var(--global-button-corner-radius-small);
    background: border-box var(--color-success);
    cursor: pointer;
    flex: 1 1 50%;
    align-self: center;
}

.button-font {
    color: var(--color-foreground);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
    line-height: 14px;
    text-align: center;
}

/* bonus code css */
.bonus {
    background-color: var(--color-background);
}

.featured-bonus {
    background-color: var(--color-brand-tertiary);
}

.bonus,
.featured-bonus {
    flex: 1 1 50%;
    padding: var(--spacing-tiny) var(--spacing-small);
    border: 1px dashed var(--color-border);
    border-radius: var(--global-button-corner-radius-small);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 22px;
    line-height: var(--spacing-smedium);
}

.bonus:hover {
    background-color: var(--color-background);
    border: 1px dashed var(--color-secondary);
}

.featured-bonus:hover {
    border: 1px dashed var(--color-secondary);
}

.bonus-code {
    color: var(--color-primary);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
}

.bonus-text {
    color: var(--color-secondary);
    font-size: var(--font-size-caption);
    font-weight: 800;
    font-size: 9px;
}

.bonus-copy {
    color: var(--color-info);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
}

.no-code {
    color: var(--color-secondary);
    font-size: var(--font-size-subcaption);
    font-weight: 800;
    line-height: var(--spacing-smedium);
}

.featured-item {
    display: block;
    text-decoration: none;
}

.featured-item__content__header {
    font-size: var(--font-size-subcaption);
    margin: 0;
    padding: var(--spacing-tiny) var(--spacing-small);
    background-color: var(--color-brand-primary);
    color: var(--color-text-white);
}

.featured-item__content__container {
    background-color: var(--color-brand-secondary);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: var(--spacing-small);
    border-bottom: 1px solid var(--color-border);
    gap: 0.5rem;
}

.featured-item__content {
    display: flex;
    align-items: center;
    flex: 1;
    flex-basis: 250px;
    gap: var(--spacing-small);
}

.item__terms-seemore {
    margin-left: 0.25rem;
    text-decoration: underline;
    cursor: pointer;
    color: var(--color-primary);
}

/* skeleton css */
.skeleton-item__logo {
    width: 35px;
    height: 35px;
    border-radius: var(--border-small);
    align-self: center;
    background-color: var(--color-background);
    animation: var(--loading);
}

.skeleton-item__description {
    flex-grow: 1;
    gap: 2px;
}
.skeleton-item__description > *:nth-of-type(odd) {
    height: var(--font-size-caption);
    width: 75px;
    background-color: var(--color-background);
    animation: var(--loading);
}
.skeleton-item__description > *:nth-of-type(even) {
    height: var(--font-size-subcaption);
    width: 100%;
    margin-top: 2px;
    margin-bottom: 2px;
    background-color: var(--color-background);
    animation: var(--loading);
}

.skeleton-button {
    background-color: var(--color-background);
    animation: var(--loading);
}

.dark-mode .item {
    background-color: var(--color-dark-background);
}

.dark-mode .item__book-name,
.dark-mode .featured-item__book-name,
.dark-mode .item__terms,
.dark-mode .featured-item__terms {
    color: var(--color-dark-secondary);
}

.dark-mode .item__cta,
.dark-mode .featured-item__cta,
.dark-mode .item__terms-seemore {
    color: var(--color-dark-primary);
}

.dark-mode .featured-bonus {
    background-color: var(--color-dark-brand-tertiary);
}

.dark-mode .featured-bonus .bonus-code,
.dark-mode .featured-bonus .bonus-text,
.dark-mode .featured-bonus .bonus-copy,
.dark-mode .featured-bonus.no-code {
    color: var(--color-dark-primary);
}
